export default __webpack_public_path__ + "static/media/MySQL.e1595fa4.jpg";